module.exports = __webpack_public_path__ + "img/home-tree.21a50d38.svg";